/**
 * @param {String} key
 * @returns {Object} json parsed item
 */
export function getFromLocalStorage(key) {
  return JSON.parse(localStorage.getItem(key));
}

/**
 * @param {String} key
 * @param {Object} value
 * @return {Boolean}
 */
export function setInLocalStorage(key, value) {
  try {
    localStorage.setItem(key, JSON.stringify(value));
    return true;
  } catch {
    return false;
  }
}
